import _ from "lodash";
import {
  doc,
  getDoc,
  query,
  getDocs,
  collection,
  updateDoc,
  where,
  orderBy,
  limit,
  deleteDoc,
  addDoc,
  setDoc,
} from "firebase/firestore";
import {
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { Firestore, Storage, SetTime } from "./firebase";
import { fetchAdvertisers, fetchError } from "../actions";

const baseIndex = {
  adNumber: "",
  advertiser: "",
  bannerTitle: "",
  bannerType: "",
  currentUser: false,
  lastModAt: "",
  lastModBy: "",
  retailer: "",
};

const buildIndex = (banner) => {
  const index = {};
  Object.keys(baseIndex).forEach((key) => {
    index[key] = banner[key] === undefined ? baseIndex[key] : banner[key];
  });
  return index;
};

export const hasRole = (user) =>
  Boolean(user) &&
  (user.isViewer === true ||
    user.isEditor === true ||
    user.isAdmin === true ||
    user.isAdOps === true);

export const createTempUser = (user) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(doc(Firestore, "tempusers", user.uid), {
        displayName: user.displayName,
      });
      return resolve();
    } catch (error) {
      return reject(error);
    }
  });
};

export const updateUser = async (id, user) => {
  return new Promise(async (resolve, reject) => {
    let person = _.omit(user, ["id"]);
    try {
      await setDoc(doc(Firestore, "users", id), person);
      return resolve();
    } catch (error) {
      return reject(error);
    }
  });
};

export const getUser = (auth) => {
  return new Promise(async (resolve, reject) => {
    const userRef = doc(Firestore, "users", auth.uid);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      let user = { ...userSnap.data(), id: auth.uid };
      return resolve(user);
    } else {
      return resolve(null);
    }
  });
};

export const deleteUser = (id) => {
  return new Promise(async (resolve, reject) => {
    await deleteDoc(doc(Firestore, "users", id));

    return resolve();
  });
};

export const createBanner = async (data, dispatch) => {
  const banner = { ...data };
  banner.lastModAt = SetTime;
  let message = {};
  const index = buildIndex(banner);

  try {
    const bannerRef = await addDoc(collection(Firestore, "banners"), banner);
    await setDoc(doc(Firestore, "banner-index", bannerRef.id), index);
    message.id = bannerRef.id;
  } catch (error) {
    message.error = error;
  }

  return message;
};

export const updateBanner = async (data, id, dispatch) => {
  const banner = { ...data };
  banner.lastModAt = SetTime;
  let message = {};
  const index = buildIndex(banner);

  const bannerRef = doc(Firestore, "banners", id);
  const bannerIndexRef = doc(Firestore, "banner-index", id);

  try {
    await updateDoc(bannerRef, banner);
    await updateDoc(bannerIndexRef, index);
    message.success = true;
  } catch (error) {
    dispatch(fetchError(error));
    message.error = error;
  }
  return message;
};

export const deleteBanner = async (id, dispatch) => {
  let message = {};
  try {
    await deleteDoc(doc(Firestore, "banner-index", id));
    await deleteDoc(doc(Firestore, "banners", id));
    message.success = `document ${id} deleted`;
  } catch (error) {
    dispatch(fetchError(error));
    message.error = error;
  }

  return message;
};

export const changeStatus = async (id, user) => {
  if (id) {
    let userId = user.id || "";
    let editor = user ? `${user.displayName} (${user.organisation})` : user;
    const bannerRef = doc(Firestore, "banners", id);
    const bannerIndexRef = doc(Firestore, "banner-index", id);

    await updateDoc(bannerRef, {
      currentUser: editor,
      userId,
    });

    await updateDoc(bannerIndexRef, {
      currentUser: editor,
      userId,
    });
  }
};

export const uploadFile = async (file, folder, callback) => {
  let now = new Date();
  now = now.getTime();
  //const child = key || field;
  const fileName = `${now}-${file.name}`;
  const storageRef = ref(Storage, `images/${folder}/${fileName}`);

  const uploadTask = uploadBytesResumable(storageRef, file);

  uploadTask.on(
    "state_changed",
    (snapshot) => {
      const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      switch (snapshot.state) {
        case "paused":
          callback({
            name: file.name,
            paused: true,
            progress: progress,
            path: "",
          });
          break;
        case "running":
          callback({
            name: file.name,
            running: true,
            progress: progress,
            path: "",
          });
          break;
        default:
          console.log("not initialized");
      }
    },
    (error) => {
      console.log("file upload error", error);
      callback({ error });
    },
    () => {
      getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
        callback({ name: file.name, path: downloadURL, progress: 100 });
      });
    }
  );
};

export const getAdvertisers = async (retailer, user, dispatch) => {
  if (user.restrictByAdvertiser) {
    if (user.advertisers) {
      dispatch(fetchAdvertisers(user.advertisers));
    } else {
      dispatch(
        fetchAdvertisers([
          {
            advertiserId: user.advertiserId,
            displayName: user.advertiser,
          },
        ])
      );
    }
  } else {
    if (user.restrictByRetailer) retailer = user.retailer;
    let advertisers = [];
    const advertisersRef = doc(Firestore, "advertisers", retailer);
    const advertisersSnap = await getDoc(advertisersRef);
    if (advertisersSnap.exists()) {
      let data = advertisersSnap.data();
      advertisers = [...data.advertisers];
    } else {
      advertisers = [];
    }
    dispatch(fetchAdvertisers(advertisers));
  }
};

export const createAdvertiser = (advertiser, retailer) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(doc(Firestore, "advertisers", retailer), advertiser);
    } catch (error) {
      return reject(error);
    }
    return resolve();
    //await Firestore.collection("advertisers")
    //  .doc(retailer)
    //  .set(advertiser)
    //  .then(() => {
    //    return resolve();
    //  })
    //  .catch((error) => {
    //    return reject(error);
    //  });
  });
};

export const deleteAdvertiser = (advertisers, id, retailer) => {
  return new Promise(async (resolve, reject) => {
    await advertisers.splice(id, 1);

    try {
      await setDoc(doc(Firestore, "advertisers", retailer), { advertisers });
    } catch (error) {
      return reject(error);
    }
    return resolve(advertisers);
    //Firestore.collection("advertisers")
    //  .doc(retailer)
    //  .set({ advertisers })
    //  .then(() => {
    //    return resolve(advertisers);
    //  })
    //  .catch((error) => {
    //    return reject(error);
    //  });
  });
};

export const getRetailers = async (user) => {
  let retailers = [];
  const q = query(collection(Firestore, "retailers"));
  const querySnapShot = await getDocs(q);

  querySnapShot.forEach((doc) => {
    retailers.push({ ...doc.data() });
  });
  if (user.restrictByRetailer) {
    retailers = retailers.filter((retailer) => {
      return retailer.name === user.retailer;
    });
  }

  return retailers;
};

export const createRetailer = (retailer) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(doc(Firestore, "retailers", retailer.name), retailer);
      return resolve(retailer);
    } catch (error) {
      return reject(error);
    }
    //Firestore.collection("retailers")
    //  .doc(retailer.name)
    //  .set(retailer)
    //  .then(() => {
    //    return resolve(retailer);
    //  })
    //  .catch((error) => {
    //    return reject(error);
    //  });
  });
};

export const getNativeTemplate = (retailer, templateId) => {
  return new Promise(async (resolve, reject) => {
    const templateRef = doc(Firestore, "templates", retailer);
    const templateSnap = await getDoc(templateRef);

    if (templateSnap.exists()) {
      let t = templateSnap.data();
      return resolve(t[templateId]);
    } else {
      return reject(new Error());
    }
  });
};

export const createNativeTemplate = (retailer, templateId, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await setDoc(
        doc(Firestore, "templates", retailer),
        {
          [templateId]: data,
        },
        { merge: true }
      );
      return resolve(true);
    } catch (error) {
      return reject(error);
    }
    //Firestore.collection("templates")
    //  .doc(retailer)
    //  .set(
    //    {
    //      [templateId]: data,
    //    },
    //    { merge: true }
    //  )
    //  .then(() => {
    //    return resolve(true);
    //  })
    //  .catch((error) => {
    //    return reject(error);
    //  });
  });
};

export const updateNativeTemplate = (retailer, templateId, data) => {
  return new Promise(async (resolve, reject) => {
    try {
      await updateDoc(doc(Firestore, "templates", retailer), {
        [templateId]: data,
      });
      return resolve("success");
    } catch (error) {
      return reject(error);
    }
    //Firestore.collection("templates")
    //  .doc(retailer)
    //  .update({
    //    [templateId]: data,
    //  })
    //  .then(() => {
    //    return resolve("success");
    //  })
    //  .catch((error) => {
    //    return reject(error);
    //  });
  });
};

export const initialQuery = (config) => {
  return config.advertiser
    ? typeof config.advertiser !== "string"
      ? query(
          collection(Firestore, "banner-index"),
          where("retailer", "==", config.retailer),
          where("advertiser", "in", config.advertiser),
          orderBy("lastModAt", "desc"),
          limit(config.limit)
        )
      : query(
          collection(Firestore, "banner-index"),
          where("retailer", "==", config.retailer),
          where("advertiser", "==", config.advertiser),
          orderBy("lastModAt", "desc"),
          limit(config.limit)
        )
    : query(
        collection(Firestore, "banner-index"),
        where("retailer", "==", config.retailer),
        orderBy("lastModAt", "desc"),
        limit(config.limit)
      );
};

export const ListQueryReducer = (state, action) => {
  switch (action.type) {
    case "retailer":
      return action.payload;
    case "search":
      return action.advertiser
        ? query(
            collection(Firestore, "banner-index"),
            where("retailer", "==", action.retailer),
            where("advertiser", "==", action.advertiser),
            where(action.search, "==", action.term),
            orderBy("lastModAt", "desc"),
            limit(action.limit)
          )
        : query(
            collection(Firestore, "banner-index"),
            where("retailer", "==", action.retailer),
            where(action.search, "==", action.term),
            orderBy("lastModAt", "desc"),
            limit(action.limit)
          );
    case "reset":
      return action.payload;
    default:
      return state;
  }
};
